<template>
    <v-card-text>
        <v-container fluid>
            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-row dense align="center" justify="center">
                        <v-col cols="12" sm="7">
                            <div class="text-center">
                                <v-img src="http://172.16.1.23:93/img/ico-activa-seguro-shield.svg" contain
                                    height="45px" max-height="45px" />
                            </div>
                            <div class="text-center mt-2">
                                <h1 class="titleSection" v-html="'¡Renueva tu seguro!'"></h1>
                                <p class="txtRojo11 mt-5" v-html="'Empezar ahora por'"></p>
                            </div>
                            <div>
                                <div class="header-shadow">
                                    <div class="text-center">
                                        <div style="height:9vh"> </div>
                                        <h3 class="cotizadorPrecio" v-html="`$${valorCouta}`"></h3>
                                        <h4 class="cotizadorPeriodo mt-3">MENSUAL</h4>
                                    </div>
                                </div>
                            </div>
                            <div class="text-center mt-10">
                                <v-btn rounded color="primary" dark @click="next">Continuar</v-btn>
                            </div>
                            <div class="text-center mt-10">
                                <h1 class="titleContactanos">¿Preguntas? Llámanos al <span
                                        style="font-weight: 700;">1-800 CONTIGO</span></h1>
                                <p class="mt-4 contenido"> Lunes a viernes de 9 AM a 6 PM. Sábados de 9 AM a 3 PM</p>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
    export default {
        name: 'windowEmpezarAhoraComponent',
        props:{
            valorCouta:{
                type:String,
                default:''
            }
        },
        inject:['next']
    }
</script>

<style>
    h1.titleSection {
        color: #FF4132;
        font-style: italic;
        font-weight: 700;
        font-size: 1.80rem;
    }

    .txtRojo11 {
        color: #ff4132;
        font-size: 1.3rem;
        font-weight: 400;
        font-style: italic;
    }

    .valorMensual {
        background: #FF4132;
        text-align: center;
        border-radius: 15px;
        padding: 6px 25px;
        color: #FFF;
        font-style: italic;
        font-weight: 600;
    }

    h1.titleContactanos {
        font-weight: 600;
        font-style: italic;
        font-size: 1.50rem;
        color: #898989;
    }

    p.contenido {
        font-size: 0.85rem;
        color: #808080;
        font-weight: 300;
        text-transform: none;
    }

    .header-shadow {
        background-image: url('http://172.16.1.23:93/img/precio-bg.svg');
        background-position: center;
        height: 25vh;
        max-height: 25vh;
    }

    h3.cotizadorPrecio {
        font-size: 1.9rem;
        line-height: 1;
        color: #fff;
        font-style: italic;
        font-weight: 600;
    }

    h4.cotizadorPeriodo {
        font-size: 1.1rem;
        margin-bottom: 0;
        line-height: 0;
        color: #fff;
        font-style: italic;
        font-weight: 600;
        text-transform: uppercase;
    }
</style>